import React from "react";
import MenuTitle from "./MenuTitle";
import { Routes, Route, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import "./App.css";
import { MsalProvider } from "@azure/msal-react";
import { CustomNavigationClient } from "./utils/NavigationClient";
import { PageLayout } from "./components/PageLayout";
import { Home } from "./pages/Home";
import { Dashboard } from "./pages/Dashboard";
import { Profile } from "./pages/Profile";
import { Login } from "./pages/Login";
import { Logout } from "./pages/Logout";
import { Customers } from "./pages/Customers";
import { Customer } from "./pages/Customer";
import { AgentContact } from "./pages/AgentContact";
import { ServiceContract } from "./pages/ServiceContract";
import { SalesDashboard } from "./pages/SalesDashboard";
import { ServiceContractManagement } from "./pages/ServiceContractManagement";
import { Bookings } from "./pages/Bookings";
import { ShipmentProcess } from "./pages/ShipmentProcess";
import { ShipmentProcessForm } from "./pages/ShipmentProcessForm";
import { SalesOrderDupOrder } from "./pages/SalesOrderDupOrder";
import { SalesOrder } from "./pages/SalesOrder";
import { SalesOrderForm } from "./pages/SalesOrderForm";
import { SalesOrderDetail } from "./pages/SalesOrderDetail";
import { JobManagment } from "./pages/JobManagment";
import { JobManagmentReport } from "./pages/JobManagmentReport";
import { ReceiveReport } from "./pages/ReceiveReport";
import { SaleInquiry } from "./pages/SaleInquiry";
import { SaleInquiryForm } from "./pages/SaleInquiryForm";
import { SaleInquiryFormRating } from "./pages/SaleInquiryFormRating";
import { SaleInquiryDetail } from "./pages/SaleInquiryDetail";
import { SendInquiry } from "./pages/SendInquiry";
import { SalesOrderUserRole } from "./pages/SalesOrderUserRole";
import { OpenJobManagement } from "./pages/OpenJobManagement";
import { SalesOrderManagement } from "./pages/SalesOrderManagement";
import { Quotation } from "./pages/Quotation";
import { QuotationForm } from "./pages/QuotationForm";
import { QuotationDetail } from "./pages/QuotationDetail";
import { QueueDetail } from "./pages/QueueDetail";
import { SaleActivity } from "./pages/SaleActivity";
import { SaleActivityForm } from "./pages/SaleActivityForm";
import { SaleActivityList } from "./pages/SaleActivityList";
import { CostSheet } from "./pages/CostSheet";
import { Datamyne } from "./pages/Datamyne";
import { AuthenProfile } from "./pages/AuthenProfile";
import { Register } from "./pages/Register";
import { User } from "./pages/User";
import { RequestUserRole } from "./pages/RequestUserRole";
import { ProfileWithMsal } from "./pages/ProfileWithMsal";
import { ProfileRawContext } from "./pages/ProfileRawContext";
import { ProfileUseMsalAuthenticationHook } from "./pages/ProfileUseMsalAuthenticationHook";
import { BookingConfirmation } from "./pages/BookingConfirmation";
import { SalesOrderReport } from "./pages/SalesOrderReport";
import { SalesOrderReportCarrier } from "./pages/SalesOrderReportCarrier";
import { LeadsManagement } from "./pages/LeadsManagement";
import { LeadsDetail } from "./pages/LeadsDetail";
import { LeadsForm } from "./pages/LeadsForm";
import { CampaignManagement } from "./pages/CampaignManagement";
import { CampaignDetail } from "./pages/CampaignDetail";
import { CampaignForm } from "./pages/CampaignForm";
import { UserManagement } from "./pages/UserManagement";
import { RolePermission } from "./pages/RolePermission";
import { MenuManagement } from "./components/Menu/MenuManagement";
import { MasterConfig } from "./pages/MasterConfig";
import Footer from "./components/Footer";
import { AssetManagement } from "./pages/AssetManagement";
import { LicensesManagement } from "./pages/LicensesManagement";
import { TicketManagement } from "./pages/TicketManagement";
import { UserForm } from "./pages/UserForm";
import { CustomerRegister } from "./pages/CustomerRegister";
import { CustomerRegisterForm } from "./pages/CustomerRegisterForm";
import { CustomerRegisterDetail } from "./pages/CustomerRegisterDetail";
import { SalesReport } from "./pages/SalesReport";
import { SalesJobTracking } from "./pages/SalesJobTracking";
import { ShipmentTrackingPage } from "./pages/ShipmentTracking";
import { USAShipmentReport } from "./pages/USAShipmentReport";
import RPAMonitor from './components/Tracking/RpaMonitor';
import { url_path } from "./shared";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme"; // 👈 import theme
function App({ pca }) {
  // The next 3 lines are optional. This is how you configure MSAL to take advantage of the router's navigate functions when MSAL redirects between pages in your app
  const navigate = useNavigate();
  const navigationClient = new CustomNavigationClient(navigate);
  pca.setNavigationClient(navigationClient);
  return (
    <MsalProvider instance={pca}>
      <PageLayout>
          <ThemeProvider theme={theme}>
         <Grid container justifyContent="center" className="MainContent">
          <Pages />
        </Grid>
  </ThemeProvider>

        <Footer />
      </PageLayout>
    </MsalProvider>
  );
}
function Pages() {
  return (
    <>
      <MenuTitle /> {/* จะทำงานทุกครั้งที่ route เปลี่ยน */}
      <Routes>
        <Route path={`${url_path}/MenuManagement`} element={<MenuManagement />} />
        <Route path={`${url_path}/UserManagement`} element={<UserManagement />} />
        <Route path={`${url_path}/RoleManagement`} element={<RolePermission />} />
        <Route path={`${url_path}/MasterConfig`} element={<MasterConfig />} />
        <Route path={`${url_path}/Home`} element={<Home />} />
        <Route path={`${url_path}/Dashboard`} element={<Dashboard />} />
        <Route path={`${url_path}/SalesReport`} element={<SalesReport />} />
        <Route path={`${url_path}/SalesJobTracking`} element={<SalesJobTracking />} />
        <Route path={`${url_path}/USAShipmentReport`} element={<USAShipmentReport />} />
        <Route path={`${url_path}/ShipmentTracking`} element={<ShipmentTrackingPage />} />
        <Route path={`${url_path}/RPAMonitor`} element={<RPAMonitor />} />
        <Route
          path={`${url_path}/SalesDashboard`}
          element={<SalesDashboard />}
        />
        <Route path={`${url_path}/Customer`} element={<Customer />} />
        <Route path={`${url_path}/Customers`} element={<Customers />} />
        <Route
          path={`${url_path}/CustomerRegister`}
          element={<CustomerRegister />}
        />
        <Route
          path={`${url_path}/CustomerRegisterForm`}
          element={<CustomerRegisterForm />}
        />
            <Route
          path={`${url_path}/CustomerRegisterDetail`}
          element={<CustomerRegisterDetail />}
        />
       
        <Route
          path={`${url_path}/ServiceContract`}
          element={<ServiceContract />}
        />
        <Route path={`${url_path}/UserForm`} element={<UserForm />} />
        <Route
          path={`${url_path}/ServiceContractManagement`}
          element={<ServiceContractManagement />}
        />
        <Route
          path={`${url_path}/LeadsManagement`}
          element={<LeadsManagement />}
        />
        <Route path={`${url_path}/LeadsDetail`} element={<LeadsDetail />} />
        <Route path={`${url_path}/LeadsForm`} element={<LeadsForm />} />
        <Route
          path={`${url_path}/CampaignManagement`}
          element={<CampaignManagement />}
        />
        <Route
          path={`${url_path}/CampaignDetail`}
          element={<CampaignDetail />}
        />
        <Route path={`${url_path}/CampaignForm`} element={<CampaignForm />} />
        <Route path={`${url_path}/AgentContact`} element={<AgentContact />} />
        <Route path={`${url_path}/Bookings`} element={<Bookings />} />
        <Route path={`${url_path}/SaleInquiry`} element={<SaleInquiry />} />
        <Route
          path={`${url_path}/SalesOrderReport`}
          element={<SalesOrderReport />}
        />
        <Route
          path={`${url_path}/JobManagmentReport`}
          element={<JobManagmentReport />}
        />
        <Route path={`${url_path}/ReceiveReport`} element={<ReceiveReport />} />
        <Route
          path={`${url_path}/OpenJobManagement`}
          element={<OpenJobManagement />}
        />

        <Route path={`${url_path}/SendInquiry`} element={<SendInquiry />} />
        <Route
          path={`${url_path}/SaleInquiryForm`}
          element={<SaleInquiryForm />}
        />
        <Route
          path={`${url_path}/SalesOrderManagement`}
          element={<SalesOrderManagement />}
        />
        <Route
          path={`${url_path}/SaleInquiryFormRating`}
          element={<SaleInquiryFormRating />}
        />
        <Route
          path={`${url_path}/SaleInquiryDetail`}
          element={<SaleInquiryDetail />}
        />
        <Route path={`${url_path}/Quotation`} element={<Quotation />} />
        <Route path={`${url_path}/QuotationForm`} element={<QuotationForm />} />
        <Route
          path={`${url_path}/QuotationDetail`}
          element={<QuotationDetail />}
        />
        <Route path={`${url_path}/SaleActivity`} element={<SaleActivity />} />
        <Route
          path={`${url_path}/SaleActivityForm`}
          element={<SaleActivityForm />}
        />
        <Route
          path={`${url_path}/SaleActivityList`}
          element={<SaleActivityList />}
        />
        <Route
          path={`${url_path}/ShipmentProcess`}
          element={<ShipmentProcess />}
        />
        <Route
          path={`${url_path}/ShipmentProcessForm`}
          element={<ShipmentProcessForm />}
        />

        <Route path={`${url_path}/QueueDetail`} element={<QueueDetail />} />
        <Route
          path={`${url_path}/SalesOrderUserRole`}
          element={<SalesOrderUserRole />}
        />
        <Route
          path={`${url_path}/SalesOrderDupOrder`}
          element={<SalesOrderDupOrder />}
        />
        <Route path={`${url_path}/SalesOrder`} element={<SalesOrder />} />
        <Route
          path={`${url_path}/SalesOrderReportCarrier`}
          element={<SalesOrderReportCarrier />}
        />
        <Route
          path={`${url_path}/SalesOrderDetail`}
          element={<SalesOrderDetail />}
        />
        <Route
          path={`${url_path}/SalesOrderForm`}
          element={<SalesOrderForm />}
        />
        <Route
          path={`${url_path}/BookingConfirmation`}
          element={<BookingConfirmation />}
        />
        <Route
          path={`${url_path}/TicketManagement`}
          element={<TicketManagement />}
        />
        <Route
          path={`${url_path}/AssetManagement`}
          element={<AssetManagement />}
        />
        <Route
          path={`${url_path}/LicensesManagement`}
          element={<LicensesManagement />}
        />
        <Route path={`${url_path}/JobManagment`} element={<JobManagment />} />
        <Route path={`${url_path}/CostSheet`} element={<CostSheet />} />
        <Route path={`${url_path}/Datamyne`} element={<Datamyne />} />
        <Route path={`${url_path}/AuthenProfile`} element={<AuthenProfile />} />
        <Route path={`${url_path}/Register`} element={<Register />} />
        <Route
          path={`${url_path}/RequestUserRole`}
          element={<RequestUserRole />}
        />
        <Route path={`${url_path}/profile`} element={<Profile />} />
        <Route path={`${url_path}/User`} element={<User />} />
        <Route
          path={`${url_path}/profileWithMsal`}
          element={<ProfileWithMsal />}
        />
        <Route
          path={`${url_path}/profileRawContext`}
          element={<ProfileRawContext />}
        />
        <Route
          path={`${url_path}/profileUseMsalAuthenticationHook`}
          element={<ProfileUseMsalAuthenticationHook />}
        />
        <Route path="/" element={<Login />} />
        <Route path={`${url_path}`} element={<Login />} />
        <Route path={`${url_path}/Login`} element={<Login />} />
        <Route path={`${url_path}/logout`} element={<Logout />} />
      </Routes>
    </>
  );
}

export default App;
